/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, total: NonNullable<unknown>, width: NonNullable<unknown>, height: NonNullable<unknown> }} Image_Export_Magnified_Event_HintInputs */



/**
* | output |
* | --- |
* | "Event {index} of {total} \| {width}x{height}" |
*
* @param {Image_Export_Magnified_Event_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_magnified_event_hint = /** @type {((inputs: Image_Export_Magnified_Event_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Magnified_Event_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Evenement ${i?.index} sur ${i?.total} | ${i?.width}x${i?.height}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ereignis ${i?.index} von ${i?.total} | ${i?.width}x${i?.height}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Evento ${i?.index} di ${i?.total} | ${i?.width}x${i?.height}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие ${i?.index} из ${i?.total} | ${i?.width}x${i?.height}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Evento ${i?.index} de ${i?.total} | ${i?.width}x${i?.height}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件 ${i?.index} 的 ${i?.total} | ${i?.width}x${i?.height}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント ${i?.index} / ${i?.total} | ${i?.width}x${i?.height}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.total} की घटना ${i?.index} | ${i?.width}x${i?.height}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Evento ${i?.index} de ${i?.total} | ${i?.width}x${i?.height}`)
	return /** @type {LocalizedString} */ (`Event ${i?.index} of ${i?.total} | ${i?.width}x${i?.height}`)
});